import { Injectable, Type, Injector, ApplicationRef, ComponentRef, ComponentFactoryResolver, EmbeddedViewRef } from '@angular/core';
import { Subject } from 'rxjs';

interface ModalOptions<T> {
  component: Type<T>;
  inputs?: Partial<T>;
}

@Injectable({
  providedIn: 'root'
})
export class CreateProjectTeamModalService {

  constructor(
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private appRef: ApplicationRef
  ) { }

  openModal<T>(options: ModalOptions<T>): Subject<any> {
    const factory = this.resolver.resolveComponentFactory(options.component);
    const componentRef = factory.create(this.injector);
    if (options.inputs) {
      Object.assign(componentRef.instance as any, options.inputs);
    }

    const results$ = new Subject<any>();
    (componentRef.instance as any).results$ = results$;

    this.appRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0];
    document.body.appendChild(domElem);

    results$.subscribe(() => {
      this.appRef.detachView(componentRef.hostView);
      componentRef.destroy();
    });

    return results$;
  }
}
